<template>
  <div class="">
    <h1>سطل زباله</h1>
    <div class="col-12 text-left">
      <router-link :to="{ name: 'TagsDashboard', }" class="">
        <button class="btn mx-1 rounded-pill btn-primary">تگ ها</button>
      </router-link>
    </div>

    <div class="my-3">
      <tag-table table-mode="trash"/>
    </div>

  </div>
</template>


<script>
import Pagination from "@/plugin/components/dashboard/Pagination.vue";
import TagTable from "@/plugin/components/dashboard/Tag/TagTable.vue";

export default {
  name: "TrashTag",
  components: {TagTable, Pagination},
}
</script>

<style scoped>

</style>